import { NextSeo } from 'next-seo';
import MerchantProcessingPage from '_components/composed/pages/MerchantProcessingPage';

export default function MerchantProcessing() {
  return (
    <>
      <NextSeo
        title="Merchant Processing Services by Incorpified - Secure and Efficient Transactions"
        description="Streamline your payment processing with Incorpified’s Merchant Processing services. Secure, efficient solutions for all your business transactions."
      />
      <MerchantProcessingPage />
    </>
  );
}
